import React from 'react'
import View from '../../../../../components/pdf/View'
import Line from '../../../../../components/pdf/Line'
import Text from '../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Separator from '../../../../../components/pdf/Separator'

const Orientation = () => {
  return (
    <View pageBreakAfter>
      <Text bold>Orientações gerais:</Text>

      <Separator weight={5} />

      <Text>
        Para atividades que requeiram posturas inadequadas (mesmo não caracterizando longos períodos), segue orientação
        sobre a realização de pausas conforme item 17.4.3.2 da NR 17:
      </Text>
      <Text>
        Para que as pausas possam propiciar descanso e recuperação psicofisiológica dos trabalhadores, devem ser
        observados os requisitos mínimos:
      </Text>
      <Text>
        a) a introdução das pausas não pode ser acompanhada de aumento da cadência individual; e – trabalhador não pode
        voltar da pausa e correr contra o tempo.
      </Text>
      <Text>
        b) as pausas devem ser usufruídas fora dos postos de trabalho. – não existe uma medida em metros, mas evitar que
        seja próximo e evitar que o trabalhador veja o posto de trabalho para não visualizar a operação e se sentir
        ansioso, voltar antes da hora etc.
      </Text>

      <Separator weight={5} />

      <Text>
        Para trabalhos em postura sentada, caso a alternância entre estar de pé e sentado para realização da tarefa não
        for de modo algum possível, estabeleça pausas curtas que permitam a troca da posição de trabalho. Orientar os
        trabalhadores para que alternem a postura pelo menos 10 minutos a cada 2 horas trabalhadas em postura sentada.
        Pode ser realizado treinamento de boas práticas ergonômicas de modo que o trabalhador seja orientado quanto à
        melhor maneira de utilizar seu posto de trabalho, seus aparatos, ferramentas e a realizar posturas adequadas
        durante as atividades laborais.
      </Text>

      <Separator weight={5} />

      <Text>
        Em ambientes com nível de pressão sonora fora dos parâmetros de conforto, pode ser estudada a implementação de
        paredes com material absorvente e o uso de placas defletoras amortecedoras de som são úteis para reduzir o nível
        de ruído e separar as linhas de produção de áreas adjacentes, a fim de impedir que efeitos perturbadores do
        barulho afetem outras áreas. Além disso. Garantir manutenção periódica às ferramentas e máquinas a fim de
        reduzir o ruído.
      </Text>

      <Separator weight={5} />

      <Text>
        Em postos de trabalho administrativos onde são utilizados notebook, proceder com o fornecimento de teclado e
        mouse independentes, bem como suporte de altura ajustável visando atender o item 17.7.3.2 da NR 17. Além disso,
        como boa prática, oferecer apoio emborrachado de mouse e teclado.
      </Text>

      <Separator weight={5} />

      <Text>
        Para trabalhos que envolva a utilização de veículos para visitas externas, a empresa deve incluir o veículo em
        uma agenda de manutenção preventiva a fim de detectar antecipadamente qualquer problema que dificulte a operação
        por parte do motorista
      </Text>

      <Separator weight={20} />
    </View>
  )
}

export default Orientation
